<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header title="意见反馈" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>
    <div class="feedback-form">
        <div class="field-line-right" ><textarea class="feedback-message field-input"  v-model="feedback" placeholder="反馈内容:" ></textarea></div>
        <flex-line class="field-line" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="pictureCode" placeholder="请输入图片验证码" /><img @click="changePictureCode"  :src="pictureCodeUrl" class="countdown" ></div></flex-line>
        <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">保存</div></div>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="feedback-list" v-if="feedback_list && feedback_list.length">
            <div class="feedback-item"  v-for="(item, index) in feedback_list">
                <div class="feedback-info">
                    <div class="p-info">
                        <div class="explain">咨询内容
                            <span class="right">{{ $moment.unix(item.fb_time).format('YYYY年MM月DD日') }}</span>
                        </div>
                        <div class="name">{{item.fb_content}}</div>
                    </div>
                </div>
            </div>
        </div>
        <empty-record v-else-if="feedback_list && !feedback_list.length"></empty-record>
    </div>
</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
import { getFeedbackList, addFeedback } from '../../../api/memberFeedback'
import { checkPictureCaptcha } from '../../../api/common'
import flexLine from '../../flexLine'
export default {
  name: 'MemberFeedback',
  data () {
    return {
      feedback: '',
      params: { 'page': 0, 'per_page': 10 },
      pictureCode: '',
      pictureCodeUrl: '',
      pictureCodeValid: false,
      feedback_list: false,
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  components: {
      flexLine,
    EmptyRecord
  },
  mounted () {
    this.changePictureCode()
  },
  created () {

  },
  watch: {
    pictureCode: function (val) {
      if (val.length >= 4) {
        this.pictureCodeWait = true
        checkPictureCaptcha(val).then(
          response => {
            this.pictureCodeWait = false
            this.pictureCodeValid = true
          },
          error => {
            this.pictureCodeWait = false
            Toast(error.message)
          }
        )
      }
    }
  },
  methods: {
    submit () {
      if (!this.pictureCode) {
        Toast('请先输入图片验证码')
        return
      }
      if (!this.feedback) {
        Toast('请先输入反馈内容')
        return
      }
      if (!this.pictureCodeValid) {
        Toast('验证码错误')
        return
      }
      addFeedback(this.feedback).then(res => {
        Toast(res.message)
        this.feedback = ''
        this.pictureCode = ''
        this.params = { 'page': 0, 'per_page': 10 }
        this.feedback_list = false
        this.loading = false
        this.isMore = true
        this.loadMore()
        this.changePictureCode()
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    changePictureCode () {
      this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getConsultList(true)
      }
    },
    getConsultList () {
      Indicator.open()
      getFeedbackList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        this.feedback_list = res.result.feedback_list.data
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }

}
</script>

<style scoped lang="scss">
    .feedback-form{background: #fff;padding:0 $pageSpace;box-shadow: 0px 4px 4px #f7f7f7;position: relative;}
	.feedback-message{background: #fbfbfb;margin: .5rem 0;font-size: .7rem;padding: .5rem;height: 4rem;border: 0;box-sizing: border-box;width: 100%;} 
    .feedback-list{background: #fff;padding:0 $pageSpace;}
    .feedback-item{background:#fff;border-bottom:1px dashed #eee;}
    .feedback-info{padding:.5rem 0;display: flex}
    .feedback-info .p-info{width: 100%;}
    .feedback-info .p-info .name{font-size:$subFontSize;color:$primaryColor;}
    .feedback-info .p-info .explain{font-size:$subFontSize;margin-bottom:.5rem}
    .feedback-info .p-info .explain .right{float:right;color:gray}
    .feedback-info .p-info .replay{font-size:$subFontSize;padding-top:.5rem;color:$descTextColor}
    .countdown{width: auto;height: 1.75rem;min-width: 4rem;}
	.field-input{
	  text-align: left !important;
	}
</style>
